import { MouseEventHandler } from 'react'

interface PreventImageDrag {
  onMouseDown: MouseEventHandler<HTMLImageElement>
}

export const preventImageDrag: PreventImageDrag = {
  onMouseDown: (event) => {
    if (event.preventDefault) event.preventDefault()
  }
}
